var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 139,
    viewBox: "0 0 400 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 139
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H400V139H0V0Z",
    fill: "#A9162A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -42.2188,
    y: 118.888,
    width: 483.971,
    height: 183.574,
    transform: "rotate(-15 -42.2188 118.888)",
    fill: "#CA1D34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42.4727,
    y: -11,
    width: 481.971,
    height: 183.725,
    transform: "rotate(15 -42.4727 -11)",
    fill: "#D2283F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -71.2578,
    y: 30.0317,
    width: 481.971,
    height: 183.725,
    transform: "rotate(15 -71.2578 30.0317)",
    fill: "#E9304A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDecoration);
export default __webpack_public_path__ + "static/media/Card-Decoration.735b0dcf9026a5d7d3f9180909666bd9.svg";
export { ForwardRef as ReactComponent };